import {Pipe, PipeTransform} from '@angular/core';
import {JOB_OPTIONS} from './constants';

/**
 * Transform the server side job type key to a pretty string.
 */
@Pipe({
    name: 'jobType',
    pure: true,
    standalone: true
})
export class JobTypePipe implements PipeTransform {
    transform(value: string, ...args: unknown[]): unknown {
        const option = JOB_OPTIONS.find(option => option.key === value);
        return option.name;
    }
}
